module.exports = __webpack_public_path__ + "img/product_20.1058082.webp";